<div class="p-7 bg-lightest">
  <div class="md:inline">
    <div class="back md:ml-10 md:inline">
      <button
        pButton
        class="back-accueil font-app-medium"
        (click)="resetView()">
        <i class="pi pi-arrow-left mr-4"></i>
        <span class="inline">{{ "homePage.back" | translate }}</span>
      </button>
    </div>
    <div class="title">
      <app-detail-title-mrh
        *ngIf="isBranchMRH"
        [titleKey]="'quotationDetail.title'"
        [reference]="reference"></app-detail-title-mrh>

      <app-detail-title-pj
        *ngIf="isBranchPJ"
        [titleKey]="'quotationDetail.titlePJ'"
        [reference]="reference"></app-detail-title-pj>

      <app-detail-title-sa
        *ngIf="isBranchSA"
        [titleKey]="'quotationDetail.titleSA'"
        [reference]="reference"></app-detail-title-sa>
    </div>
  </div>
  <div class="border-light border rounded-md shadow-none bg-white p-2 lg:ml-9 lg:w-[50%]">
    <div class="bg-lightest pb-2">
      <div class="flex justify-between p-4">
        <app-address-mrh
          *ngIf="isBranchMRH"
          [bgLogo]="'bg-white'"
          [colorLogo]="'text-primary'"
          [data]="addressData"></app-address-mrh>

        <app-title-pj
          *ngIf="isBranchPJ"
          [bgLogo]="'bg-white'"
          [colorLogo]="'primary'"></app-title-pj>

        <app-title-sa
          *ngIf="isBranchSA"
          [bgLogo]="'bg-white'"
          [colorLogo]="'primary'"
          [animalName]="animalName"></app-title-sa>

        <app-status-card
          *ngIf="quotationDetails"
          [status]="getCustomStatus(quotationDetails)"
          [statusConfig]="quotationStatusConfig"
          class="justify-end" />
      </div>
      <div class="p-1">
        <app-detail-info-card-mrh
          *ngIf="isBranchMRH"
          [validityDate]="quotationDetails.validityDate"
          [monthlyPremiumTTC]="quotationDetails.monthlyPremiumTTC"
          [promotionCode]="quotationDetails.promotionCode"
          [untilTextKey]="'quotation.until'"
          [amountTextKey]="'quotation.amount'"
          [promoTextKey]="'quotationDetail.promo'"></app-detail-info-card-mrh>

        <app-detail-info-card-pj
          *ngIf="isBranchPJ"
          [validityDate]="quotationDetails.validityDate"
          [monthlyPremiumTTC]="quotationDetails.monthlyPremiumTTC"
          [promotionCode]="quotationDetails.promotionCode"
          [untilTextKey]="'quotation.until'"
          [amountTextKey]="'quotation.amount'"
          [promoTextKey]="'quotationDetail.promo'"></app-detail-info-card-pj>

        <app-detail-info-card-sa
          *ngIf="isBranchSA"
          [validityDate]="quotationDetails.validityDate"
          [monthlyPremiumTTC]="quotationDetails.monthlyPremiumTTC"
          [promotionCode]="quotationDetails.promotionCode"
          [untilTextKey]="'quotation.until'"
          [amountTextKey]="'quotation.amount'"
          [promoTextKey]="'quotationDetail.promo'"></app-detail-info-card-sa>
      </div>

      <div class="p-4 md:p-4 font-app-bold mx-auto mb-3">
        <p-tabView
          [(activeIndex)]="activeIndex"
          (onChange)="activeIndexChange($event)">
          <p-tabPanel
            header="Mon devis"
            class="font-app-regular">
            @if (isBranchMRH) {
              <app-options-list-mrh
                *ngIf="isBranchMRH"
                [details]="quotationDetails"></app-options-list-mrh>

              <app-scholar-insurance-mrh
                *ngIf="
                  quotationDetails && quotationDetails.schoolInsuredChildsVM.childrenList.length > 0 && isBranchMRH
                "
                [children]="child"></app-scholar-insurance-mrh>
            } @else if (isBranchPJ) {
              <app-options-list-pj
                *ngIf="isBranchPJ"
                [details]="quotationDetails"></app-options-list-pj>
            } @else if (isBranchSA) {
              <app-options-list-sa
                *ngIf="isBranchSA"
                [details]="quotationDetails"></app-options-list-sa>
            }
            <button
              *ngIf="
                quotationDetails &&
                quotationDetails.status !== quotationStates.Study &&
                quotationDetails.status !== quotationStates.ToValidate &&
                quotationDetails.status !== quotationStates.Expired
              "
              title="Reprendre mon devis"
              pButton
              label="Reprendre mon devis"
              class="flex justify-center w-full rounded-md bg-primary text-white p-3 mt-5 text-sm md:text-base"
              (click)="quotationSubscription()"></button>
          </p-tabPanel>
          <p-tabPanel header="Mes documents">
            <app-documents-card
              *ngIf="quotationDetails && quotationDetails.documents.length > 0"
              [documents]="quotationDetails.documents"
              [documentName]="documentTypes"></app-documents-card>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  </div>
</div>
